import React, { useEffect } from "react";
import { useAdvertisement } from "@redux/advertisement";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import NewChart from "./NewChart";
import CompareBarChart from "./Chart/CompareBarChart";
import SimpleBarChart from "./Chart/SimpleBarChart";

const DashBoardBody = ({ dates, filterAD, statCheck }) => {
  const advertisement = useAdvertisement();

  useEffect(() => {
    advertisement.stats(dates.start, dates.end, (d, response) => {
      if (response.status === 200) {
        statCheck(d.result);
      } else {
        alert("데이터가 없습니다.");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dates]);
  return (
    <>
      {filterAD.stats.now ? (
        <Grid container spacing={4} sx={{ mt: 6 }}>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Paper
              sx={{
                boxShadow: 0,
                pt: 5.25,
                pb: 5.25,
                borderRadius: "10px",
                border: "1px solid #EEEEEF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="column">
                <Typography
                  variant="h3"
                  sx={{ pl: 6.75, pr: 6.75, pb: 4 }}
                  fontWeight={500}
                  color="grey.800"
                >
                  일간 클릭수
                </Typography>
                <NewChart
                  chartData={filterAD.stats.now.total_cnt_click}
                  text={"클릭수"}
                />
              </Grid>
            </Paper>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Paper
              sx={{
                boxShadow: 0,
                pt: 5.25,
                pb: 5.25,
                borderRadius: "10px",
                border: "1px solid #EEEEEF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="column">
                <Typography
                  variant="h3"
                  sx={{ pl: 6.75, pr: 6.75, pb: 4 }}
                  fontWeight={500}
                  color="grey.800"
                >
                  일간 노출수
                </Typography>
                <NewChart
                  chartData={filterAD.stats.now.total_cnt_view}
                  text={"노출수"}
                />
              </Grid>
            </Paper>
          </Grid>

          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Paper
              sx={{
                boxShadow: 0,
                pt: 5.25,
                pb: 5.25,
                borderRadius: "10px",
                border: "1px solid #EEEEEF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="column">
                <Typography
                  variant="h3"
                  sx={{ pl: 6.75, pr: 6.75, pb: 4 }}
                  fontWeight={500}
                  color="grey.800"
                >
                  누적 클릭수
                </Typography>
                <NewChart
                  chartData={filterAD.stats.now.acc_cnt_click}
                  text={"클릭수"}
                />
              </Grid>
            </Paper>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Paper
              sx={{
                boxShadow: 0,
                pt: 5.25,
                pb: 5.25,
                borderRadius: "10px",
                border: "1px solid #EEEEEF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="column">
                <Typography
                  variant="h3"
                  sx={{ pl: 6.75, pr: 6.75, pb: 4 }}
                  fontWeight={500}
                  color="grey.800"
                >
                  누적 노출수
                </Typography>
                <NewChart
                  chartData={filterAD.stats.now.acc_cnt_view}
                  text={"노출수"}
                />
              </Grid>
            </Paper>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Paper
              sx={{
                boxShadow: 0,
                pt: 5.25,
                pb: 5.25,
                borderRadius: "10px",
                border: "1px solid #EEEEEF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="column">
                <Typography
                  variant="h3"
                  sx={{ pl: 6.75, pr: 6.75, pb: 4 }}
                  fontWeight={500}
                  color="grey.800"
                >
                  성별 클릭수
                </Typography>
                <CompareBarChart
                  boy={filterAD.stats.now.genderMClick}
                  girl={filterAD.stats.now.genderFClick}
                  text={"클릭수"}
                />
              </Grid>
            </Paper>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Paper
              sx={{
                boxShadow: 0,
                pt: 5.25,
                pb: 5.25,
                borderRadius: "10px",
                border: "1px solid #EEEEEF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="column">
                <Typography
                  variant="h3"
                  sx={{ pl: 6.75, pr: 6.75, pb: 4 }}
                  fontWeight={500}
                  color="grey.800"
                >
                  성별 노출수
                </Typography>
                <CompareBarChart
                  boy={filterAD.stats.now.genderMView}
                  girl={filterAD.stats.now.genderFView}
                  text={"노출수"}
                />
              </Grid>
            </Paper>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Paper
              sx={{
                boxShadow: 0,
                pt: 5.25,
                pb: 5.25,
                borderRadius: "10px",
                border: "1px solid #EEEEEF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="column">
                <Typography
                  variant="h3"
                  sx={{ pl: 6.75, pr: 6.75, pb: 4 }}
                  fontWeight={500}
                  color="grey.800"
                >
                  연령별 클릭수
                </Typography>
                <SimpleBarChart
                  data={filterAD.stats.now.click}
                  text={"클릭수"}
                />
              </Grid>
            </Paper>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Paper
              sx={{
                boxShadow: 0,
                pt: 5.25,
                pb: 5.25,
                borderRadius: "10px",
                border: "1px solid #EEEEEF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="column">
                <Typography
                  variant="h3"
                  sx={{ pl: 6.75, pr: 6.75, pb: 4 }}
                  fontWeight={500}
                  color="grey.800"
                >
                  연령별 노출수
                </Typography>
                <SimpleBarChart
                  data={filterAD.stats.now.view}
                  text={"노출수"}
                />
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default DashBoardBody;
